// extracted by mini-css-extract-plugin
export default {"button_joinUs_home":"PopUpJoinUs_button_joinUs_home__6IRPy","closeIcon":"PopUpJoinUs_closeIcon__SYSrm"};